import type { ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { cx } from "class-variance-authority";

const cn = (...inputs: ClassValue[]) => twMerge(cx(inputs));

export default cn;
